<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.7131 9.22498C25.5218 9.02498 25.2826 9 25.0435 9H20.0217V6C20.0217 5.45 19.5435 5 19.0174 5H10.9826C10.4565 5 9.97826 5.45 9.97826 6V9H4.95652C4.43043 9 4 9.325 4 9.875V24C4 24.55 4.43043 25 4.95652 25H25.0435C25.5696 25 26 24.55 26 24V9.92499C26 9.64999 25.9044 9.42497 25.7131 9.22498ZM11.8913 7H18.1087V9H11.8913V7ZM24.087 11V16.25H17.3913V15.875C17.3913 15.45 17.0087 15.25 16.6022 15.25H13.3739C12.9674 15.25 12.5848 15.475 12.5848 15.875V16.25H5.88914V11H24.087ZM15.9565 16.75V17.25H14.0435V16.75H15.9565ZM5.91304 23V17.75H12.6087V18C12.6087 18.425 12.9913 18.75 13.3978 18.75H16.6261C17.0326 18.75 17.4152 18.4 17.4152 18V17.75H24.1109V23H5.91304Z" fill="#00527F"/>
  </svg>
</template>

<script>
  export default {
    name: 'thingIcon'
  }
</script>
